(() => {
  /* ================= CONFIGURACIÓN ================= */

  const H = {
    bolso: 'bolso-deportivo-magnetico',
    guantes: 'guantes-de-entrenamiento-fitness',
    rinonera: 'rinonera-deportiva-elastica-bolsillo-telefono-gym-outdoor',
    toalla: 'toalla-microfibra-secado-rapido-deportiva-gym-yoga-playa'
  };

  const LABEL = {
    bolso: 'Bolso',
    guantes: 'Guantes',
    rinonera: 'Riñonera',
    toalla: 'Toalla'
  };

  const UPSELL_KEYS = ['toalla', 'guantes', 'rinonera'];

  // Carrito vacío:
  // el bolso magnético siempre aparece primero.
  const EMPTY_CART_KEYS = [
    'bolso',
    'guantes',
    'toalla',
    'rinonera'
  ];

  // Packs de mayor a menor.
  const PACKS = [
    {
      key: 'c4',
      handle: 'combo-c4-bolso-guante-toalla-rinonera-completo',
      name: 'Pack Completo',
      items: ['bolso', 'guantes', 'toalla', 'rinonera']
    },
    {
      key: 'c3',
      handle: 'combo-c3-bolso-guante-rinonera',
      name: 'Pack Pro',
      items: ['bolso', 'guantes', 'rinonera']
    },
    {
      key: 'c2',
      handle: 'combo-c2-bolso-guante',
      name: 'Pack Fuerza',
      items: ['bolso', 'guantes']
    },
    {
      key: 'c1',
      handle: 'combo-c1-bolso-toalla-oferta',
      name: 'Pack Esencial',
      items: ['bolso', 'toalla']
    }
  ];

  /* ================================================= */

  const root =
    (window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root) ||
    '/';

  const SECTIONS =
    'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer';

  const DRAWER_BOX = 'GtUpsellDrawer';
  const PAGE_BOX = 'GtUpsellPage';

  const keyOfHandle = Object.fromEntries(
    Object.entries(H).map(([k, v]) => [v, k])
  );

  const packByHandle = Object.fromEntries(
    PACKS.map((p) => [p.handle, p])
  );

  const cache = {};

  let cartPromise = null;
  let lastSig = null;
  let lastEmpty = false;
  let running = false;
  let again = false;
  let timer = null;

  /* ================= UTILIDADES ================= */

  const moneyFormatter =
    new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    });

  const clp = (c) =>
    moneyFormatter.format(
      Math.round((c || 0) / 100)
    );

  const esc = (s) =>
    String(s ?? '').replace(
      /[&<>"']/g,
      (ch) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[ch]
    );

  const names = (keys) => {
    const n = keys.map(
      (k) => LABEL[k]
    );

    return n.length > 1
      ? n.slice(0, -1).join(', ') +
          ' + ' +
          n[n.length - 1]
      : n[0];
  };

  const imgUrl = (src, width = 128) => {
    if (!src) return '';

    if (src.startsWith('//')) {
      src = 'https:' + src;
    }

    return (
      src +
      (src.includes('?') ? '&' : '?') +
      `width=${width}`
    );
  };

  const getProduct = (h) => {
    if (cache[h]) {
      return cache[h];
    }

    cache[h] = fetch(
      `${root}products/${h}.js`,
      {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'force-cache'
      }
    )
      .then((r) =>
        r.ok ? r.json() : null
      )
      .catch(() => null);

    return cache[h];
  };

  const getCart = () => {
    if (cartPromise) {
      return cartPromise;
    }

    cartPromise = fetch(
      `${root}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store'
      }
    )
      .then((r) => {
        if (!r.ok) {
          throw new Error('No se pudo leer el carrito');
        }

        return r.json();
      })
      .finally(() => {
        cartPromise = null;
      });

    return cartPromise;
  };

  const isCartPage = () =>
    /\/cart\/?$/.test(
      location.pathname
    );

  /* =================================================
     DESCUENTO POR CANTIDAD
     ================================================= */

  const getDescuentoPorCantidad = (
    cart
  ) => {
    let items = [];
    let total = 0;

    cart.items.forEach((item) => {
      if (item.quantity >= 2) {
        const descPorUnidad =
          Math.round(
            item.price * 0.15
          );

        const ahorro =
          descPorUnidad *
          (item.quantity - 1);

        items.push({
          title: item.title,
          qty: item.quantity,
          ahorro
        });

        total += ahorro;
      }
    });

    return items.length > 0
      ? { items, total }
      : null;
  };

  /* ================= AJAX ================= */

  async function post(
    url,
    body
  ) {
    const r = await fetch(
      root + url,
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        credentials: 'same-origin',
        body: JSON.stringify(body)
      }
    );

    const j =
      await r.json();

    if (
      !r.ok ||
      j.status
    ) {
      throw new Error(
        j.description ||
          j.message ||
          'Error de carrito'
      );
    }

    return j;
  }

  /* =================================================
     ANALIZAR CARRITO
     ================================================= */

  function analyze(cart) {
    const lines = {};

    const owned =
      new Set();

    cart.items.forEach(
      (it) => {
        const k =
          keyOfHandle[
            it.handle
          ];

        if (k) {
          (
            lines[k] =
              lines[k] ||
              []
          ).push(it);

          owned.add(k);
        }

        /*
         * Si actualmente ya existe
         * un pack dentro del carrito,
         * consideramos esos productos
         * como poseídos para no volver
         * a sugerirlos individualmente.
         */
        const p =
          packByHandle[
            it.handle
          ];

        if (p) {
          p.items.forEach(
            (x) =>
              owned.add(x)
          );
        }
      }
    );

    /*
     * =================================================
     * REGLA DE PACKS
     * =================================================
     *
     * Los packs se activan únicamente cuando
     * existen 2 O MÁS PRODUCTOS DISTINTOS
     * del pack en el carrito.
     *
     * Ejemplos:
     *
     * Bolso = NO pack.
     *
     * Bolso x2 = NO pack.
     *
     * Bolso + Guantes = SÍ pack.
     *
     * Bolso + Toalla = SÍ pack.
     *
     * Guantes + Riñonera = puede sugerir
     * un pack superior si ambos pertenecen.
     */

    const full =
      PACKS.find(
        (p) => {
          const have =
            p.items.filter(
              (k) =>
                lines[k]
            );

          return (
            have.length >= 2 &&
            have.length ===
              p.items.length
          );
        }
      ) || null;

    let upgrade = null;

    PACKS.forEach(
      (p) => {
        /*
         * Si ya encontramos
         * un pack exacto,
         * no evaluamos packs
         * iguales o menores.
         */
        if (
          full &&
          p.items.length <=
            full.items.length
        ) {
          return;
        }

        const have =
          p.items.filter(
            (k) =>
              lines[k]
          );

        const miss =
          p.items.filter(
            (k) =>
              !lines[k]
          );

        /*
         * CLAVE:
         *
         * mínimo 2 productos
         * DISTINTOS tienen que
         * coincidir con el pack.
         */
        if (
          have.length < 2
        ) {
          return;
        }

        /*
         * Si ya está completo,
         * lo maneja "full".
         */
        if (
          !miss.length
        ) {
          return;
        }

        /*
         * Máximo sugerimos agregar
         * 2 productos faltantes.
         */
        if (
          miss.length > 2
        ) {
          return;
        }

        /*
         * Evitamos sugerencias
         * demasiado agresivas:
         *
         * debe tener tantos
         * productos como los que
         * faltan o más.
         */
        if (
          have.length <
          miss.length
        ) {
          return;
        }

        /*
         * Priorizamos el pack
         * más completo.
         */
        if (
          !upgrade ||
          p.items.length >
            upgrade.pack
              .items.length
        ) {
          upgrade = {
            pack: p,
            have,
            miss
          };
        }
      }
    );

    /* =================================================
       PRODUCTOS INDIVIDUALES
       ================================================= */

    let singles;

    /*
     * Carrito vacío:
     * mostrar todos,
     * bolso primero.
     */
    if (
      !cart.item_count
    ) {
      singles =
        EMPTY_CART_KEYS.filter(
          (k) =>
            !owned.has(k)
        );
    } else {
      /*
       * Carrito con productos:
       * recomendamos complementos.
       */
      singles =
        UPSELL_KEYS.filter(
          (k) =>
            !owned.has(k)
        );

      /*
       * El bolso sigue disponible
       * como recomendación si no
       * está en el carrito.
       */
      if (
        !owned.has(
          'bolso'
        )
      ) {
        singles.push(
          'bolso'
        );
      }
    }

    return {
      lines,
      full,
      upgrade,
      singles
    };
  }

  /* =================================================
     CONSTRUIR BLOQUE
     ================================================= */

  async function build(
    cart
  ) {
    const a =
      analyze(cart);

    const handles =
      new Set(
        a.singles.map(
          (k) => H[k]
        )
      );

    [
      a.full,
      a.upgrade &&
        a.upgrade.pack
    ].forEach(
      (p) => {
        if (p) {
          handles.add(
            p.handle
          );

          p.items.forEach(
            (k) =>
              handles.add(
                H[k]
              )
          );
        }
      }
    );

    const list = [
      ...handles
    ];

    const data = {};

    (
      await Promise.all(
        list.map(
          getProduct
        )
      )
    ).forEach(
      (p, i) => {
        data[
          list[i]
        ] = p;
      }
    );

    const price = (k) =>
      data[H[k]]
        ? data[H[k]]
            .price
        : 0;

    const packInfo = (
      p
    ) => {
      const pd =
        data[
          p.handle
        ];

      if (
        !pd ||
        !pd.available ||
        p.items.some(
          (k) =>
            !data[
              H[k]
            ]
        )
      ) {
        return null;
      }

      const sum =
        p.items.reduce(
          (s, k) =>
            s +
            price(k),
          0
        );

      return (
        sum - pd.price >
        0
      )
        ? {
            pd,
            sum,
            save:
              sum -
              pd.price
          }
        : null;
    };

    let html = '';

    const isEmpty =
      !cart.item_count;

    /* =================================================
       CARRITO VACÍO
       ================================================= */

    if (isEmpty) {
      html += `
        <div class="gt-ups-empty-intro">

          <span class="gt-ups-empty-intro__badge">
            Recomendado GymTonic
          </span>

          <p class="gt-ups-empty-intro__title">
            Empieza por el favorito
          </p>

          <p class="gt-ups-empty-intro__text">
            Nuestro producto estrella es el
            <strong>Bolso Magnético</strong>.
          </p>

        </div>
      `;
    }

    /* =================================================
       DESCUENTO CANTIDAD
       ================================================= */

    const descCantidad =
      getDescuentoPorCantidad(
        cart
      );

    if (
      descCantidad
    ) {
      const listItems =
        descCantidad.items
          .map(
            (d) =>
              `<strong>${esc(
                d.title
              )}</strong> (x${d.qty})`
          )
          .join(', ');

      html += `
        <div class="gt-ups-pack gt-ups-descuento">

          <span class="gt-ups-pack__tag">
            15% OFF en cantidad
          </span>

          <p class="gt-ups-pack__title">
            ¡Tienes descuento por cantidad!
          </p>

          <p class="gt-ups-pack__text">
            Llevas ${listItems}
            y ahorras
            <strong>
              ${clp(
                descCantidad.total
              )}
            </strong>
            en checkout automáticamente.
          </p>

        </div>
      `;
    }

    /* =================================================
       PACK EXACTO
       ================================================= */

    if (
      a.full
    ) {
      const i =
        packInfo(
          a.full
        );

      if (i) {
        html += `
          <div class="gt-ups-pack">

            <span class="gt-ups-pack__tag">
              Ahorras ${clp(
                i.save
              )}
            </span>

            <p class="gt-ups-pack__title">
              Tienes ${esc(
                names(
                  a.full
                    .items
                )
              )} por separado
            </p>

            <p class="gt-ups-pack__text">
              Cámbialos por el
              <strong>
                ${esc(
                  a.full.name
                )}
              </strong>
              y paga
              ${clp(
                i.pd.price
              )}
              en vez de
              ${clp(
                i.sum
              )}.
            </p>

            <button
              type="button"
              class="gt-ups-btn"
              data-gt-swap="${a.full.key}"
            >
              Cambiar a ${esc(
                a.full.name
              )}
            </button>

          </div>
        `;
      }
    }

    /* =================================================
       COMPLETAR PACK MAYOR
       ================================================= */

    if (
      a.upgrade
    ) {
      const u =
        a.upgrade;

      const i =
        packInfo(
          u.pack
        );

      if (i) {
        const extra =
          i.pd.price -
          u.have.reduce(
            (s, k) =>
              s +
              price(k),
            0
          );

        const missValue =
          u.miss.reduce(
            (s, k) =>
              s +
              price(k),
            0
          );

        if (
          extra > 0
        ) {
          html += `
            <div class="gt-ups-pack">

              <span class="gt-ups-pack__tag">
                Ahorras ${clp(
                  i.save
                )}
              </span>

              <p class="gt-ups-pack__title">
                Completa el
                ${esc(
                  u.pack.name
                )}
              </p>

              <p class="gt-ups-pack__text">

                Suma
                ${esc(
                  names(
                    u.miss
                  )
                )}

                (valen
                ${clp(
                  missValue
                )})

                pagando solo

                <strong>
                  ${clp(
                    extra
                  )} más
                </strong>.

              </p>

              <button
                type="button"
                class="gt-ups-btn"
                data-gt-swap="${u.pack.key}"
              >
                Llevar ${esc(
                  u.pack.name
                )}
              </button>

            </div>
          `;
        }
      }
    }

    /* =================================================
       PRODUCTOS RECOMENDADOS
       ================================================= */

    const cards =
      a.singles
        .map(
          (k) => {
            const p =
              data[
                H[k]
              ];

            if (!p) {
              return '';
            }

            const av =
              p.variants.filter(
                (v) =>
                  v.available
              );

            if (
              !av.length
            ) {
              return '';
            }

            const variantImage = (v) =>
              imgUrl(
                (
                  v.featured_image &&
                  v.featured_image.src
                ) ||
                  p.featured_image
              );

            const picker =
              av.length > 1
                ? `
                  <select
                    class="gt-ups-item__select"
                    data-gt-variant
                    aria-label="Elegir variante de ${esc(p.title)}"
                  >
                    ${av
                      .map(
                        (v) =>
                          `<option
                            value="${v.id}"
                            data-price="${v.price}"
                            data-image="${esc(variantImage(v))}"
                          >
                            ${esc(v.title)}
                          </option>`
                      )
                      .join('')}
                  </select>
                `
                : `
                  <input
                    type="hidden"
                    data-gt-variant
                    value="${av[0].id}"
                  >
                `;

            const src =
              variantImage(av[0]);

            const featured =
              isEmpty &&
              k ===
                'bolso';

            return `
              <div
                class="gt-ups-item${
                  featured
                    ? ' gt-ups-item--featured'
                    : ''
                }"
              >

                ${
                  src
                    ? `
                      <img
                        class="gt-ups-item__img"
                        src="${src}"
                        alt="${esc(
                          p.title
                        )}"
                        width="64"
                        height="64"
                        loading="lazy"
                        decoding="async"
                        fetchpriority="low"
                      >
                    `
                    : `
                      <span class="gt-ups-item__img"></span>
                    `
                }

                <div class="gt-ups-item__info">

                  ${
                    featured
                      ? `
                        <span class="gt-ups-item__badge">
                          Producto estrella
                        </span>
                      `
                      : ''
                  }

                  <span class="gt-ups-item__name">
                    ${esc(
                      p.title
                    )}
                  </span>

                  <span class="gt-ups-item__price">
                    ${clp(
                      av[0]
                        .price
                    )}
                  </span>

                  ${picker}

                </div>

                <button
                  type="button"
                  class="gt-ups-btn gt-ups-btn--small"
                  data-gt-add
                >
                  ${
                    featured
                      ? 'Agregar bolso'
                      : 'Agregar'
                  }
                </button>

              </div>
            `;
          }
        )
        .join('');

    if (cards) {
      const heading =
        isEmpty
          ? 'Productos recomendados para ti'
          : 'Complementa tu entrenamiento';

      html += `
        <p class="gt-ups__heading">
          ${heading}
        </p>

        <div class="gt-ups__list">
          ${cards}
        </div>
      `;
    }

    return html;
  }

  /* =================================================
     SINCRONIZAR
     ================================================= */

  function getTargets() {
    const targets = [];

    const drawerItems =
      document.querySelector(
        '#CartDrawer cart-drawer-items'
      );

    const drawerEmpty =
      document.querySelector(
        '#CartDrawer .drawer__inner-empty'
      );

    if (drawerItems) {
      targets.push({
        el: drawerItems,
        id: DRAWER_BOX,
        mode: 'append'
      });
    } else if (drawerEmpty) {
      targets.push({
        el: drawerEmpty,
        id: DRAWER_BOX,
        mode: 'append'
      });
    }

    const pageForm =
      document.querySelector(
        'cart-items form#cart'
      );

    const pageEmpty =
      document.querySelector(
        '.cart__warnings, #main-cart-items .cart__warnings'
      );

    if (pageForm) {
      targets.push({
        el: pageForm,
        id: PAGE_BOX,
        mode: 'after'
      });
    } else if (pageEmpty) {
      targets.push({
        el: pageEmpty,
        id: PAGE_BOX,
        mode: 'append'
      });
    }

    return targets;
  }

  async function sync() {
    if (running) {
      again = true;
      return;
    }

    const targets =
      getTargets();

    /*
     * Si el carrito no existe en el DOM,
     * evitamos una petición de red innecesaria.
     */
    if (!targets.length) {
      return;
    }

    running = true;

    try {
      const cart =
        await getCart();

      const sig =
        cart.items
          .map(
            (i) =>
              i.key +
              ':' +
              i.quantity
          )
          .join('|');

      const missing =
        targets.some(
          (t) =>
            !document.getElementById(
              t.id
            )
        );

      if (
        sig === lastSig &&
        (
          !missing ||
          lastEmpty
        )
      ) {
        return;
      }

      const html =
        await build(cart);

      lastSig = sig;
      lastEmpty = !html;

      targets.forEach(
        (t) => {
          let box =
            document.getElementById(
              t.id
            );

          if (!html) {
            box?.remove();
            return;
          }

          if (!box) {
            box =
              document.createElement(
                'div'
              );

            box.id = t.id;
            box.className = 'gt-ups';
            box.setAttribute(
              'data-gt-ups',
              ''
            );

            if (
              t.mode === 'append'
            ) {
              t.el.appendChild(box);
            } else {
              t.el.insertAdjacentElement(
                'afterend',
                box
              );
            }
          }

          /*
           * No reescribimos el DOM si el contenido
           * ya es idéntico. Evita parpadeos y trabajo
           * extra del navegador.
           */
          if (
            box.__gtHtml !== html
          ) {
            box.innerHTML = html;
            box.__gtHtml = html;
          }
        }
      );
    } catch (e) {
      console.debug(
        'GymTonic upsell:',
        e
      );
    } finally {
      running = false;

      if (again) {
        again = false;
        schedule(120);
      }
    }
  }

  function schedule(
    delay = 180
  ) {
    clearTimeout(timer);

    timer = setTimeout(
      sync,
      delay
    );
  }

  /* =================================================
     REFRESCAR CARRITO
     ================================================= */

  function replaceSection(
    id,
    html
  ) {
    if (!html) {
      return false;
    }

    const current =
      document.getElementById(id);

    if (!current) {
      return false;
    }

    const doc =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const next =
      doc.getElementById(id);

    if (!next) {
      return false;
    }

    current.replaceWith(next);
    return true;
  }

  async function getFreshCartState() {
    const sectionNames =
      'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer';

    const [cart, sectionResponse] =
      await Promise.all([
        getCart(),
        fetch(
          `${root}?sections=${encodeURIComponent(sectionNames)}`,
          {
            headers: {
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            cache: 'no-store'
          }
        )
      ]);

    if (!sectionResponse.ok) {
      throw new Error(
        'No se pudieron refrescar las secciones del carrito'
      );
    }

    return {
      cart,
      sections:
        await sectionResponse.json()
    };
  }

  function publishCartUpdate() {
    if (
      typeof publish !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined'
    ) {
      return;
    }

    try {
      publish(
        PUB_SUB_EVENTS.cartUpdate,
        {
          source: 'gt-upsell'
        }
      );
    } catch (e) {}
  }

  async function refresh(
    state
  ) {
    lastSig = null;

    let sections =
      state && state.sections
        ? state.sections
        : null;

    let cart = null;

    /*
     * CLAVE PARA MOBILE Y CARRITO VACÍO:
     * pedimos el HTML NUEVO del carrito después de
     * agregar. Así no dependemos de una sección que
     * el tema haya renderizado con el estado vacío.
     */
    try {
      const fresh =
        await getFreshCartState();

      cart = fresh.cart;
      sections = fresh.sections;
    } catch (e) {
      console.debug(
        'GymTonic refresh sections:',
        e
      );

      try {
        cart = await getCart();
      } catch (err) {}
    }

    const drawer =
      document.querySelector(
        'cart-drawer'
      );

    if (
      !isCartPage() &&
      drawer &&
      sections &&
      sections['cart-drawer']
    ) {
      const isEmpty =
        cart
          ? cart.item_count === 0
          : false;

      let rendered = false;

      if (
        typeof drawer.renderContents ===
        'function'
      ) {
        try {
          drawer.renderContents({
            id:
              state && state.id
                ? state.id
                : null,
            sections
          });

          rendered = true;
        } catch (e) {
          console.debug(
            'GymTonic renderContents:',
            e
          );
        }
      }

      /*
       * Fallback universal para temas Shopify que no
       * actualizan correctamente vacío -> con producto.
       */
      if (!rendered) {
        const doc =
          new DOMParser()
            .parseFromString(
              sections['cart-drawer'],
              'text/html'
            );

        const nextDrawer =
          doc.querySelector(
            'cart-drawer'
          );

        if (nextDrawer) {
          drawer.innerHTML =
            nextDrawer.innerHTML;

          rendered = true;
        }
      }

      if (rendered) {
        drawer.classList.toggle(
          'is-empty',
          isEmpty
        );

        replaceSection(
          'cart-icon-bubble',
          sections['cart-icon-bubble']
        );

        /*
         * Si el usuario agregó desde el drawer vacío,
         * lo mantenemos abierto y mostramos el producto
         * inmediatamente.
         */
        if (!isEmpty) {
          requestAnimationFrame(
            () => {
              try {
                if (
                  typeof drawer.open ===
                  'function'
                ) {
                  drawer.open();
                } else {
                  drawer.classList.add(
                    'active'
                  );
                }
              } catch (e) {}
            }
          );
        }

        publishCartUpdate();
        observeCartRoots();
        schedule(50);
        return;
      }
    }

    /*
     * En /cart actualizamos por AJAX.
     */
    if (
      isCartPage() &&
      sections
    ) {
      const changedItems =
        replaceSection(
          'main-cart-items',
          sections[
            'main-cart-items'
          ]
        );

      replaceSection(
        'main-cart-footer',
        sections[
          'main-cart-footer'
        ]
      );

      replaceSection(
        'cart-icon-bubble',
        sections[
          'cart-icon-bubble'
        ]
      );

      if (changedItems) {
        publishCartUpdate();
        observeCartRoots();
        schedule(50);
        return;
      }
    }

    publishCartUpdate();

    /*
     * Último fallback: solo recargamos si el tema no
     * permitió actualizar el carrito por AJAX.
     */
    location.reload();
  }

  /* =================================================
     CAMBIAR PRODUCTOS POR PACK
     ================================================= */

  async function swapToPack(
    pack
  ) {
    const cart =
      await getCart();

    const {
      lines
    } = analyze(
      cart
    );

    const pd =
      await getProduct(
        pack.handle
      );

    if (!pd) {
      throw new Error(
        'Pack no encontrado'
      );
    }

    /*
     * Variantes disponibles
     * ordenadas por stock.
     */
    const available =
      pd.variants
        .filter(
          (v) =>
            v.available
        )
        .map(
          (v) => ({
            ...v,
            stock:
              v.inventory_quantity ||
              0
          })
        )
        .sort(
          (a, b) =>
            b.stock -
            a.stock
        );

    if (
      available.length ===
      0
    ) {
      throw new Error(
        'Pack sin stock'
      );
    }

    /*
     * Intentar mantener
     * el color del bolso.
     */
    const bolso =
      lines.bolso &&
      lines.bolso[0];

    const color =
      bolso
        ? String(
            bolso.variant_title ||
              ''
          ).toLowerCase()
        : '';

    let variant =
      available.find(
        (v) =>
          color &&
          v.title
            .toLowerCase() ===
            color
      );

    /*
     * Si no coincide color:
     * variante con más stock.
     */
    if (!variant) {
      variant =
        available[0];

      console.debug(
        `GymTonic: No hay color ${color}, usando variante con mayor stock: ${variant.title} (${variant.stock} unidades)`
      );
    } else {
      console.debug(
        `GymTonic: Usando variante con color ${color} (${variant.stock} unidades en stock)`
      );
    }

    /*
     * Primero agregamos
     * el pack.
     */
    await post(
      'cart/add.js',
      {
        items: [
          {
            id: variant.id,
            quantity: 1
          }
        ]
      }
    );

    /*
     * Luego reducimos
     * los productos individuales
     * incluidos en ese pack.
     */
    const updates =
      {};

    pack.items.forEach(
      (k) => {
        const it =
          lines[k] &&
          lines[k][0];

        if (it) {
          const newQty =
            Math.max(
              0,
              it.quantity -
                1
            );

          updates[
            it.key
          ] = newQty;
        }
      }
    );

    return post(
      'cart/update.js',
      {
        updates,
        sections:
          SECTIONS
      }
    );
  }
  /* =================================================
     VARIANTES / COLOR
     ================================================= */

  document.addEventListener(
    'change',
    (e) => {
      const variantSelect =
        e.target.closest(
          '[data-gt-ups] select[data-gt-variant]'
        );

      if (!variantSelect) {
        return;
      }

      /*
       * Evita que cart-items / cart-drawer-items
       * de Shopify interprete este selector como
       * un selector de cantidad.
       */
      e.stopPropagation();
      e.stopImmediatePropagation();

      const option =
        variantSelect.selectedOptions &&
        variantSelect.selectedOptions[0];

      const card =
        variantSelect.closest(
          '.gt-ups-item'
        );

      if (
        !option ||
        !card
      ) {
        return;
      }

      const price =
        Number(
          option.dataset.price ||
          0
        );

      const image =
        option.dataset.image ||
        '';

      const priceEl =
        card.querySelector(
          '.gt-ups-item__price'
        );

      const imageEl =
        card.querySelector(
          'img.gt-ups-item__img'
        );

      if (
        price &&
        priceEl
      ) {
        priceEl.textContent =
          clp(price);
      }

      if (
        image &&
        imageEl &&
        imageEl.src !== image
      ) {
        imageEl.src = image;
      }
    },
    true
  );

  /* =================================================
     BOTONES
     ================================================= */

  document.addEventListener(
    'click',
    async (e) => {
      const btn =
        e.target.closest(
          '[data-gt-ups] [data-gt-add], [data-gt-ups] [data-gt-swap]'
        );

      if (
        !btn ||
        btn.disabled
      ) {
        return;
      }

      e.preventDefault();

      const label =
        btn.textContent.trim();

      btn.disabled = true;
      btn.setAttribute(
        'aria-busy',
        'true'
      );

      btn.textContent =
        btn.hasAttribute(
          'data-gt-swap'
        )
          ? 'Cambiando…'
          : 'Agregando…';

      try {
        let res;

        if (
          btn.hasAttribute(
            'data-gt-add'
          )
        ) {
          const id =
            Number(
              btn
                .closest(
                  '.gt-ups-item'
                )
                .querySelector(
                  '[data-gt-variant]'
                )
                .value
            );

          res =
            await post(
              'cart/add.js',
              {
                items: [
                  {
                    id,
                    quantity:
                      1
                  }
                ],

                sections:
                  SECTIONS
              }
            );
        } else {
          const pack =
            PACKS.find(
              (p) =>
                p.key ===
                btn.dataset
                  .gtSwap
            );

          if (!pack) {
            throw new Error(
              'Pack no encontrado'
            );
          }

          res =
            await swapToPack(
              pack
            );
        }

        btn.setAttribute(
          'aria-busy',
          'false'
        );

        if (
          btn.hasAttribute(
            'data-gt-add'
          )
        ) {
          btn.textContent =
            '✓ Agregado';

          btn.classList.add(
            'gt-ups-btn--success'
          );
        }

        await refresh(res);
      } catch (err) {
        console.debug(
          'GymTonic upsell:',
          err
        );

        btn.textContent =
          'Sin stock. Prueba otra opción';

        setTimeout(
          () => {
            btn.textContent =
              label;

            btn.disabled = false;
            btn.setAttribute(
              'aria-busy',
              'false'
            );
          },
          2200
        );
      }
    }
  );

  /* =================================================
     OBSERVER
     ================================================= */

  const WATCH =
    'cart-drawer, cart-items';

  const observedRoots =
    new WeakSet();

  const observer =
    new MutationObserver(
      (mutations) => {
        const relevant =
          mutations.some(
            (m) => {
              const t =
                m.target.nodeType === 1
                  ? m.target
                  : m.target.parentElement;

              if (
                !t ||
                t.closest(
                  '[data-gt-ups]'
                )
              ) {
                return false;
              }

              const added = [
                ...m.addedNodes
              ].filter(
                (n) =>
                  n.nodeType === 1
              );

              if (
                added.length &&
                !m.removedNodes.length &&
                added.every(
                  (n) =>
                    n.matches(
                      '[data-gt-ups]'
                    )
                )
              ) {
                return false;
              }

              return true;
            }
          );

        if (relevant) {
          schedule();
        }
      }
    );

  function observeCartRoots() {
    document
      .querySelectorAll(WATCH)
      .forEach((el) => {
        if (
          observedRoots.has(el)
        ) {
          return;
        }

        observedRoots.add(el);
        observer.observe(
          el,
          {
            childList: true,
            subtree: true
          }
        );
      });
  }

  /* =================================================
     CSS
     ================================================= */

  const css = `

.gt-ups{
  --gt-green:#2EE68C;
  --gt-bg:#181c22;
  --gt-bg-2:#242833;
  --gt-text:#f7f9f8;
  --gt-muted:rgba(247,249,248,.74);
  --gt-border:rgba(255,255,255,.09);

  display:grid;
  gap:10px;
  width:100%;
  max-width:100%;
  margin:14px 0 8px;
  color:var(--gt-text);
  container-type:inline-size;
  box-sizing:border-box
}

.gt-ups *,
.gt-ups *::before,
.gt-ups *::after{
  box-sizing:border-box
}

#GtUpsellPage{
  max-width:860px;
  margin:6px 0 24px
}

.gt-ups__heading{
  margin:4px 0 0;
  font-size:clamp(1.15rem,1.4vw,1.35rem);
  font-weight:800;
  line-height:1.25;
  letter-spacing:.01em;
  color:#fff
}

.gt-ups__list{
  display:grid;
  grid-template-columns:1fr;
  gap:8px
}

#GtUpsellPage .gt-ups__list{
  grid-template-columns:repeat(2,minmax(0,1fr));
  gap:10px
}

/* CARRITO VACÍO */

.gt-ups-empty-intro,
.gt-ups-pack,
.gt-ups-item{
  contain:layout paint;
  overflow:hidden
}

.gt-ups-empty-intro{
  padding:15px 16px;
  border:1px solid rgba(46,230,140,.30);
  border-radius:16px;
  background:linear-gradient(
    145deg,
    rgba(46,230,140,.11),
    rgba(255,255,255,.025)
  )
}

.gt-ups-empty-intro__badge,
.gt-ups-item__badge{
  display:inline-flex;
  align-items:center;
  width:max-content;
  max-width:100%;
  padding:4px 9px;
  border-radius:999px;
  background:var(--gt-green);
  color:#07130d;
  font-size:1rem;
  font-weight:850;
  line-height:1.2
}

.gt-ups-empty-intro__title{
  margin:8px 0 3px;
  font-size:clamp(1.3rem,1.7vw,1.5rem);
  font-weight:850;
  line-height:1.25;
  color:#fff
}

.gt-ups-empty-intro__text{
  margin:0;
  max-width:62ch;
  font-size:1.12rem;
  line-height:1.45;
  color:var(--gt-muted)
}

.gt-ups-empty-intro__text strong{
  color:#fff
}

/* PACK */

.gt-ups-pack{
  padding:14px 15px;
  border:1px solid rgba(46,230,140,.34);
  border-radius:16px;
  background:linear-gradient(
    145deg,
    rgba(46,230,140,.10),
    rgba(255,255,255,.02)
  )
}

.gt-ups-descuento{
  border-color:rgba(255,193,7,.36);
  background:linear-gradient(
    145deg,
    rgba(255,193,7,.10),
    rgba(255,255,255,.02)
  )
}

.gt-ups-descuento .gt-ups-pack__tag{
  background:#ffc107;
  color:#333
}

.gt-ups-pack__tag{
  display:inline-flex;
  align-items:center;
  max-width:100%;
  padding:4px 10px;
  border-radius:999px;
  background:var(--gt-green);
  color:#07130d;
  font-size:1.02rem;
  font-weight:850;
  line-height:1.2
}

.gt-ups-pack__title{
  margin:8px 0 3px;
  font-size:clamp(1.22rem,1.5vw,1.4rem);
  font-weight:800;
  line-height:1.3;
  color:#fff
}

.gt-ups-pack__text{
  margin:0 0 11px;
  font-size:1.12rem;
  line-height:1.45;
  color:var(--gt-muted)
}

.gt-ups-pack__text strong{
  color:#fff
}

/* PRODUCTOS */

.gt-ups-item{
  display:grid;
  grid-template-columns:56px minmax(0,1fr) auto;
  grid-template-areas:"image info button";
  align-items:center;
  gap:10px;
  min-width:0;
  padding:9px 10px;
  border:1px solid var(--gt-border);
  border-radius:15px;
  background:var(--gt-bg)
}

.gt-ups-item--featured{
  padding:11px;
  border-color:rgba(46,230,140,.52);
  background:linear-gradient(
    145deg,
    rgba(46,230,140,.11),
    var(--gt-bg)
  )
}

.gt-ups-item__img{
  grid-area:image;
  display:block;
  width:56px;
  height:56px;
  aspect-ratio:1;
  object-fit:cover;
  border-radius:11px;
  background:var(--gt-bg-2)
}

.gt-ups-item--featured .gt-ups-item__img{
  width:62px;
  height:62px
}

.gt-ups-item__info{
  grid-area:info;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  gap:2px;
  min-width:0
}

.gt-ups-item__name{
  display:-webkit-box;
  max-width:100%;
  overflow:hidden;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:2;
  font-size:1.16rem;
  font-weight:750;
  line-height:1.25;
  color:#fff
}

.gt-ups-item__price{
  font-size:1.12rem;
  font-weight:850;
  line-height:1.2;
  color:var(--gt-green)
}

.gt-ups-item__select{
  width:auto;
  max-width:150px;
  min-height:28px;
  margin-top:3px;
  padding:3px 26px 3px 8px;
  border:1px solid rgba(255,255,255,.16);
  border-radius:999px;
  background:var(--gt-bg-2);
  color:#fff;
  font:inherit;
  font-size:1rem;
  line-height:1.2
}

/* BOTONES */

.gt-ups-btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:100%;
  min-height:44px;
  padding:8px 16px;
  border:0;
  border-radius:999px;
  background:var(--gt-green);
  color:#07130d;
  font:inherit;
  font-size:1.18rem;
  font-weight:850;
  line-height:1.15;
  text-align:center;
  cursor:pointer;
  touch-action:manipulation;
  -webkit-tap-highlight-color:transparent;
  transition:filter .14s ease,transform .14s ease
}

.gt-ups-btn:hover{
  filter:brightness(1.05)
}

.gt-ups-btn:active{
  filter:brightness(.96);
  transform:translateY(1px)
}

.gt-ups-btn:disabled{
  opacity:.62;
  cursor:wait
}

.gt-ups-btn:focus-visible,
.gt-ups-item__select:focus-visible{
  outline:2px solid #fff;
  outline-offset:2px
}

.gt-ups-btn--success{
  background:var(--gt-green)!important;
  border-color:var(--gt-green)!important;
  color:#07130d!important
}

.gt-ups-btn--small{
  grid-area:button;
  width:auto;
  min-width:86px;
  min-height:38px;
  padding:7px 13px;
  border:1px solid rgba(46,230,140,.48);
  background:transparent;
  color:var(--gt-green);
  font-size:1.04rem;
  white-space:nowrap
}

/* El contenedor manda: perfecto tanto en drawer como en página */

@container (max-width:430px){
  .gt-ups{
    gap:9px;
    margin:12px 0 9px
  }

  .gt-ups-empty-intro,
  .gt-ups-pack{
    padding:12px 13px;
    border-radius:14px
  }

  .gt-ups__heading{
    margin-top:5px;
    font-size:1.12rem
  }

  .gt-ups-item{
    grid-template-columns:50px minmax(0,1fr);
    grid-template-areas:
      "image info"
      "button button";
    gap:8px 9px;
    padding:9px;
    border-radius:14px
  }

  .gt-ups-item__img{
    width:50px;
    height:50px;
    border-radius:10px
  }

  .gt-ups-item--featured .gt-ups-item__img{
    width:54px;
    height:54px
  }

  .gt-ups-item__name{
    font-size:1.08rem
  }

  .gt-ups-item__price{
    font-size:1.06rem
  }

  .gt-ups-item__select{
    max-width:132px;
    min-height:30px;
    font-size:.98rem
  }

  .gt-ups-btn--small{
    width:100%;
    min-height:40px;
    font-size:1.06rem
  }
}

@container (max-width:330px){
  .gt-ups-item{
    grid-template-columns:44px minmax(0,1fr)
  }

  .gt-ups-item__img,
  .gt-ups-item--featured .gt-ups-item__img{
    width:44px;
    height:44px
  }

  .gt-ups-empty-intro__badge,
  .gt-ups-item__badge,
  .gt-ups-pack__tag{
    font-size:.92rem
  }

  .gt-ups-pack__text,
  .gt-ups-empty-intro__text{
    font-size:1rem
  }
}

/* Fallback mobile si el navegador no soporta container queries */

@media(max-width:749px){
  #GtUpsellDrawer .gt-ups-item{
    grid-template-columns:50px minmax(0,1fr);
    grid-template-areas:
      "image info"
      "button button"
  }

  #GtUpsellDrawer .gt-ups-btn--small{
    width:100%;
    min-height:42px
  }

  #GtUpsellPage{
    margin:8px 0 18px
  }

  #GtUpsellPage .gt-ups__list{
    grid-template-columns:1fr
  }

  .gt-ups-btn{
    min-height:42px
  }
}

/* DESKTOP: drawer compacto y realmente de escritorio.
   Aunque el drawer sea angosto, no usamos el layout mobile. */
@media(min-width:750px){
  #GtUpsellDrawer{
    gap:8px;
    margin:10px 0 8px
  }

  #GtUpsellDrawer .gt-ups-empty-intro,
  #GtUpsellDrawer .gt-ups-pack{
    padding:11px 13px;
    border-radius:13px
  }

  #GtUpsellDrawer .gt-ups-empty-intro__badge,
  #GtUpsellDrawer .gt-ups-item__badge,
  #GtUpsellDrawer .gt-ups-pack__tag{
    padding:3px 8px;
    font-size:.9rem
  }

  #GtUpsellDrawer .gt-ups-empty-intro__title{
    margin:6px 0 2px;
    font-size:1.18rem
  }

  #GtUpsellDrawer .gt-ups-empty-intro__text,
  #GtUpsellDrawer .gt-ups-pack__text{
    font-size:1rem;
    line-height:1.35
  }

  #GtUpsellDrawer .gt-ups__heading{
    margin:3px 0 1px;
    font-size:1.04rem
  }

  #GtUpsellDrawer .gt-ups__list{
    gap:7px
  }

  #GtUpsellDrawer .gt-ups-item,
  #GtUpsellDrawer .gt-ups-item--featured{
    grid-template-columns:48px minmax(0,1fr) auto;
    grid-template-areas:
      "image info button";
    gap:8px;
    padding:8px 9px;
    border-radius:12px
  }

  #GtUpsellDrawer .gt-ups-item__img,
  #GtUpsellDrawer .gt-ups-item--featured .gt-ups-item__img{
    width:48px;
    height:48px;
    border-radius:9px
  }

  #GtUpsellDrawer .gt-ups-item__name{
    font-size:1rem;
    line-height:1.18;
    -webkit-line-clamp:2
  }

  #GtUpsellDrawer .gt-ups-item__price{
    font-size:1rem
  }

  #GtUpsellDrawer .gt-ups-item__select{
    max-width:112px;
    min-height:27px;
    margin-top:2px;
    padding:2px 24px 2px 7px;
    font-size:.9rem
  }

  #GtUpsellDrawer .gt-ups-btn--small{
    width:auto;
    min-width:76px;
    min-height:34px;
    padding:5px 10px;
    font-size:.92rem
  }
}

@media(
  prefers-reduced-motion:reduce
){
  .gt-ups-btn{
    transition:none
  }
}

`;

  /* =================================================
     INICIAR
     ================================================= */

  const start = () => {
    if (
      !document.getElementById(
        'GtUpsellStyles'
      )
    ) {
      const style =
        document.createElement(
          'style'
        );

      style.id =
        'GtUpsellStyles';

      style.textContent = css;
      document.head.appendChild(style);
    }

    observeCartRoots();

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        () => {
          observeCartRoots();
          schedule(100);
        }
      );
    }

    /*
     * Si el usuario va directo al carrito,
     * priorizamos la sincronización antes del click.
     */
    const cartIntent = (e) => {
      if (
        !e.target.closest(
          'a[href*="/cart"], .header__icon--cart, [id*="cart-icon"], [aria-controls*="CartDrawer"]'
        )
      ) {
        return;
      }

      observeCartRoots();
      schedule(0);

      /*
       * Algunos temas insertan el drawer recién
       * después del click. Hacemos una segunda
       * comprobación muy liviana.
       */
      setTimeout(
        () => {
          observeCartRoots();
          schedule(0);
        },
        100
      );
    };

    document.addEventListener(
      'pointerdown',
      cartIntent,
      {
        capture: true,
        passive: true
      }
    );

    document.addEventListener(
      'click',
      cartIntent,
      true
    );

    window.addEventListener(
      'pageshow',
      () => {
        lastSig = null;
        observeCartRoots();
        schedule(50);
      }
    );

    document.addEventListener(
      'shopify:section:load',
      () => {
        observeCartRoots();
        schedule(80);
      }
    );

    /*
     * Dejamos que el contenido crítico de la página
     * cargue primero. En idle preparamos el carrito.
     */
    const boot = () => {
      observeCartRoots();
      sync();
    };

    if (
      'requestIdleCallback' in window
    ) {
      requestIdleCallback(
        boot,
        { timeout: 900 }
      );
    } else {
      setTimeout(
        boot,
        220
      );
    }
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
